const VideoLandingPageClient = {
  landingPageURL: "/assessment/recommendation",
  getVideoUrl: "/candidate/course_video",
  getQuery: "/video_query",
  quizData: "/pop_quiz/start",
  submitQuizData: "/pop_quiz",
};

export default VideoLandingPageClient;
